<template>
  <ul class="nav nav-custom border-start align-items-center">
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle column-toggle-link"
        role="button"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
      >
        <i class="fa-solid fa-table-columns me-1" />
        {{ $t('Columns') }}
        <span class="badge rounded-pill bg-theme ms-1">
          {{ modelValue.length }}/{{ togglableHeaders.length }}
        </span>
      </a>
      <ul class="dropdown-menu dropdown-menu-end column-toggle-menu">
        <li class="px-3 py-2 d-flex justify-content-between align-items-center column-toggle-header">
          <small class="text-muted text-uppercase fw-semibold">
            {{ $t('Show Columns') }}
          </small>
          <div class="btn-group btn-group-sm">
            <button
              type="button"
              class="btn btn-link btn-sm p-0 text-theme fw-semibold"
              @click.prevent="selectAll"
            >
              {{ $t('All') }}
            </button>
            <span class="text-muted mx-1">|</span>
            <button
              type="button"
              class="btn btn-link btn-sm p-0 text-muted fw-semibold"
              @click.prevent="clearAll"
            >
              {{ $t('None') }}
            </button>
          </div>
        </li>
        <li><hr class="dropdown-divider my-1" /></li>
        <li
          v-for="header in togglableHeaders"
          :key="header.value"
          class="column-toggle-item"
        >
          <label
            class="dropdown-item d-flex align-items-center gap-2 mb-0"
            :for="`${uid}-${header.value}`"
          >
            <input
              class="form-check-input m-0"
              type="checkbox"
              :id="`${uid}-${header.value}`"
              :value="header.value"
              :checked="modelValue.includes(header.value)"
              @change="toggle(header.value, $event.target.checked)"
            />
            <span>{{ header.text }}</span>
          </label>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ColumnToggle',
  props: {
    headers: { type: Array, required: true },
    modelValue: { type: Array, required: true },
    storageKey: { type: String, required: true }
  },
  emits: ['update:modelValue'],
  computed: {
    togglableHeaders() {
      return this.headers.filter(h => h.togglable);
    },
    uid() {
      return this.storageKey.replace(/[^a-z0-9]/gi, '-');
    }
  },
  watch: {
    modelValue: {
      handler(val) {
        localStorage.setItem(this.storageKey, JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    toggle(value, checked) {
      const next = checked
        ? [...this.modelValue, value]
        : this.modelValue.filter(v => v !== value);
      this.$emit('update:modelValue', next);
    },
    selectAll() {
      this.$emit('update:modelValue', this.togglableHeaders.map(h => h.value));
    },
    clearAll() {
      this.$emit('update:modelValue', []);
    }
  }
}
</script>

<style scoped>
.column-toggle-link {
  cursor: pointer;
  user-select: none;
}
.column-toggle-menu {
  min-width: 240px;
  padding: 0.5rem;
  border-radius: 0.875rem;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.06);
  margin-top: 0.5rem !important;
}
.column-toggle-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.625rem;
  padding: 0.625rem 0.875rem !important;
  margin-bottom: 0.25rem;
}
.column-toggle-item {
  padding: 0 0.125rem;
}
.column-toggle-item .dropdown-item {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color 0.15s ease;
  margin: 0.125rem 0;
}
.column-toggle-item .dropdown-item:hover {
  background-color: rgba(233, 108, 21, 0.08);
  color: inherit;
}
.column-toggle-item .form-check-input {
  cursor: pointer;
  flex-shrink: 0;
  width: 1.05rem;
  height: 1.05rem;
}
.column-toggle-item .form-check-input:checked {
  background-color: #E96C15;
  border-color: #E96C15;
}
.column-toggle-item .form-check-input:focus {
  border-color: #eeb084;
  box-shadow: 0 0 0 0.2rem rgba(233, 108, 21, 0.2);
}
:deep(.dropdown-divider) {
  margin: 0.375rem 0.25rem;
  border-color: rgba(0, 0, 0, 0.06);
}
</style>
